import React from 'react'
import { IconProps } from '../../types/types'

const MergeIcon:React.FC<IconProps> = ({ color = '#1E1E1E', size = '20' }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.5 14.9834L4.62499 14.9918C5.38332 14.9918 6.09166 14.6167 6.50833 13.9917L11.8333 6.00844C12.25 5.38344 12.9583 5.0001 13.7167 5.00843L17.5083 5.02512" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M15.8333 16.6501L17.4999 14.9834" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M7.40835 7.18347L6.50833 5.93347C6.08333 5.34181 5.39999 4.99181 4.67499 5.00015L2.5 5.00849" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M10.8083 12.8169L11.825 14.1252C12.25 14.6752 12.9167 15.0002 13.6167 15.0002L17.5084 14.9835" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M17.4999 5.01676L15.8333 3.3501" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

export default MergeIcon